//Make sure to use inside useEffect
const insertScript = (position, src, id = null, async = true, defer = false) => {
	if (document.querySelector(`script[src^="${src}"]`)) return;

	const script = Object.assign(document.createElement("script"), {
		src,
		id,
		async: async && !defer,
		defer,
	});

	(position === "head" ? document.head : document.body).appendChild(script);
};

export default insertScript;
